/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Event_NameInputs */

const en_cp_p_event_name = /** @type {(inputs: Cp_P_Event_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competitions & hackathons`)
};

const id_cp_p_event_name = /** @type {(inputs: Cp_P_Event_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompetisi & hackathon`)
};

/**
* | output |
* | --- |
* | "Competitions & hackathons" |
*
* @param {Cp_P_Event_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_event_name = /** @type {((inputs?: Cp_P_Event_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Event_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_event_name(inputs)
	return en_cp_p_event_name(inputs)
});